import { Pipe, PipeTransform } from '@angular/core';
import { formatNcarbDate, ModeType } from '../utility/date-utils';

@Pipe({ name: 'ncarbDateTimeFormat' })
export class NcarbDateTimeFormatPipe implements PipeTransform {
  transform(date: Date, mode: ModeType = 'date') {
    return formatNcarbDate(date, mode);
  }
}
